import { render, staticRenderFns } from "./CardDetailsAssignees.vue?vue&type=template&id=d19ee506&"
import script from "./CardDetailsAssignees.vue?vue&type=script&lang=js&"
export * from "./CardDetailsAssignees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports